import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_d5xrgr19y5: FaireBrandEntity = {
  token: "b_d5xrgr19y5",
  type: "brand",
  name: "Fable England",
  avatarUrl:
    "https://cdn.faire.com/fastly/195a5ccfcf543d6e6a5dc4f25e49a9ec9dab384cdbfad9880f242cce5b827d48.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/05b228ff78f4725635c1b9bc936384a027fbd1c8822e6f26d46d5afd556127e9.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/195a5ccfcf543d6e6a5dc4f25e49a9ec9dab384cdbfad9880f242cce5b827d48.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/05b228ff78f4725635c1b9bc936384a027fbd1c8822e6f26d46d5afd556127e9.jpeg",
  location: "NJ, USA",
  minimumOrderDollars: 200,
  rating: 4.8,
  reviewCount: 220,
  isInsider: true,
  description:
    "Inspired by the heritage of storytelling and vintage charms, Fable celebrates our glorious British countryside, all the wondrous creatures and delicate flowers that thrive within. Collect your favourites, share them with loved ones, and create your own story. Delicately hand-painted enamel jewellery in keepsake boxes, 'it' bags, silk-like scarves, and coordinating cosmetic bags - every one has a story.\nOur goods are not available to sell on eBay or Amazon.\n\nShipping from Salt Lake City, Utah warehouse.",
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:56:11.062Z",
    importedBy: "entity-db-cli",
  },
};
